import React from "react";

const ReceiptIcon = ({ fill, ...restProps }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M5.746 1.703c-.991.069-1.671.353-2.264.946-.611.612-.88 1.275-.949 2.346-.018.28-.031 3.082-.031 6.555.001 6.563-.01 6.174.179 6.447.213.307.697.416 1.025.232.086-.049.539-.368 1.008-.709s.867-.62.886-.62c.018 0 .405.296.858.658.454.362.867.677.918.7.156.07.344.085.524.042.139-.033.349-.17 1.127-.736.526-.383.964-.696.973-.696s.447.313.973.696c.778.566.988.703 1.127.736.18.043.368.028.524-.042.051-.023.464-.338.918-.7.453-.362.84-.658.858-.658s.418.279.886.62c1.068.778 1.101.797 1.381.796q.496-.003.744-.464l.072-.135v-6.4c0-6.746.002-6.675-.15-7.27-.153-.598-.569-1.23-1.075-1.632-.464-.37-.977-.583-1.653-.686-.308-.048-8.223-.071-8.859-.026m8.885 1.708c.552.148.976.572 1.125 1.125.054.198.059.619.069 5.777.009 4.525.003 5.557-.032 5.529l-.55-.401c-.383-.278-.547-.377-.677-.408a.82.82 0 0 0-.523.042c-.051.023-.464.338-.918.7s-.84.658-.859.658c-.018 0-.417-.279-.885-.62-1.067-.777-1.101-.796-1.381-.796s-.314.019-1.381.796c-.468.341-.867.62-.885.62s-.405-.296-.859-.658-.867-.677-.918-.7a.82.82 0 0 0-.523-.042c-.13.031-.294.13-.677.408-.279.202-.526.382-.55.401-.035.028-.041-1.004-.032-5.529.01-5.158.015-5.579.069-5.777.075-.277.211-.512.412-.713.287-.287.564-.408 1.044-.456.138-.014 2.155-.023 4.483-.02 3.894.006 4.251.011 4.448.064"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
};

export default ReceiptIcon;
